/* Framework-free SVG output: a standalone SVG document for a layout, ready to
   save as a .svg file, inline in HTML, or rasterize to PNG. */

import { drawLayout, Shape } from './draw';
import { KohdLayout } from './layout';

export interface SvgOptions {
  /** Line and fill color. */
  ink?: string;
  /** Background color; also used for the halos where traces cross. */
  paper?: string;
  /** Show each word's text under its glyph. */
  labels?: boolean;
}

const escapeText = (v: string) => v.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
const escapeAttr = (v: string) => escapeText(v).replace(/"/g, '&quot;');

export function shapeToSvg(shape: Shape): string {
  const attrs = Object.entries(shape.attrs)
    .filter(([, v]) => v !== undefined)
    .map(([k, v]) => ` ${k}="${escapeAttr(String(v))}"`)
    .join('');
  const inner = shape.children ? shape.children.map(shapeToSvg).join('') : escapeText(shape.text ?? '');
  return inner ? `<${shape.tag}${attrs}>${inner}</${shape.tag}>` : `<${shape.tag}${attrs}/>`;
}

export function kohdSvg(layout: KohdLayout, { ink = '#1a1330', paper = '#ffffff', labels = false }: SvgOptions = {}): string {
  const { minX, minY, maxX, maxY } = layout.bounds;
  const width = Math.ceil(maxX - minX);
  const height = Math.ceil(maxY - minY);
  const style = `.kohd-halo{stroke:${paper}}.kohd-label{fill:${ink};fill-opacity:.6;font:600 18px Georgia,serif;letter-spacing:.08em}`;
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${minX} ${minY} ${width} ${height}" width="${width}" height="${height}" color="${escapeAttr(ink)}">`
    + `<style>${escapeText(style)}</style>`
    + `<rect x="${minX}" y="${minY}" width="${width}" height="${height}" fill="${escapeAttr(paper)}"/>`
    + drawLayout(layout, { labels }).map(shapeToSvg).join('')
    + '</svg>';
}
